import React, { useEffect, useRef } from 'react';
import { dispatcher } from 'dispatcher';
import { compose } from 'ramda';

import { GameLayout } from 'js/app/components/main/Games/components/GameLayout';
import { Skeleton } from 'js/app/components/main/Skeleton';

import { useBingoSchedule } from 'js/app/components/main/Games/components/GameCategory/components/BingoList/hooks/useBingoSchedule';
import { setBingoSchedule } from 'js/app/components/main/Games/components/GameCategory/components/BingoList/store/actions';
import { useBingoListDispatch, withBingoListProvider } from 'js/app/components/main/Games/components/GameCategory/components/BingoList/store/context';
import { useCustomCategory } from 'js/app/components/main/Games/hooks/useCustomCategory';
import { SKELETON_TYPES } from 'js/app/components/main/Skeleton/constants';

export const BingoListBare = ({
    category,
    bingoParams = {},
    viewModeInline
}) => {
    const dispatch = useBingoListDispatch();
    const accRemoveBingoGames = useRef([]);
    const customCategory = useCustomCategory(category?.name);

    const {
        lobbyName,
        maxCount,
        minCount,
        requestCount
    } = { ...customCategory, ...bingoParams };

    const { state: { data } } = useBingoSchedule({
        lobbyName,
        minCount,
        requestCount
    });

    useEffect(() => {
        const handlerRemoveBingoGames = (name) => {
            if (!accRemoveBingoGames.current.length) {
                setTimeout(() => {
                    const bingoSchedule = data.reduce((acc, item) => {
                        if (accRemoveBingoGames.current.includes(item.name)) {
                            return acc;
                        }

                        acc.push(item);

                        return acc;
                    }, []);

                    dispatch(setBingoSchedule(bingoSchedule));

                    accRemoveBingoGames.current = [];
                }, 300);
            }

            accRemoveBingoGames.current.push(name);
        };

        dispatcher.listen('removeBingoGame', handlerRemoveBingoGames);

        return () => {
            dispatcher.removeListener('removeBingoGame', handlerRemoveBingoGames);
        };
    }, [data, dispatch]);

    if (!data?.length) {
        return (
            <Skeleton configuration={[{ type: SKELETON_TYPES.bingoScheduler, count: minCount }]} />
        );
    }

    return (
        <GameLayout
            isBingo
            viewModeInline={viewModeInline}
            gameList={data?.slice(0, maxCount)}
        />
    );
};

export const BingoList = compose(withBingoListProvider)(BingoListBare);
